import React, { useState, useEffect } from 'react';

const UserModal = ({ isOpen, mode, initialData, onClose, onSave, onToggleActive }) => {
  const [formData, setFormData] = useState({
    id: null, full_name: '', email: '', phone: '', role: 'operator', is_active: true
  });

  useEffect(() => {
    if (initialData && Object.keys(initialData).length > 0) {
      setFormData({
        id: initialData.id,
        full_name: initialData.full_name || initialData.name || '',
        email: initialData.email || '',
        phone: initialData.phone || '',
        role: initialData.role || 'operator',
        is_active: initialData.is_active !== false // Defaults to true
      });
    } else {
      setFormData({ id: null, full_name: '', email: '', phone: '', role: 'operator', is_active: true });
    }
  }, [initialData, isOpen]);

  if (!isOpen) return null;

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ width: '650px' }}>
        
        <div className="modal-header">
          <h2 style={{ margin: 0, fontSize: '1.5rem', fontWeight: 500 }}>
            {mode === 'create' ? 'Create User Account' : 'Edit User Account'}
          </h2>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>

        <div className="form-grid">
          <div className="form-group">
            <label>User full name</label>
            <input type="text" name="full_name" placeholder="e.g., Dr. Sarah Al-Rashid" value={formData.full_name} onChange={handleInputChange} required />
          </div>
          <div className="form-group">
            <label>Email Address</label>
            <input type="email" name="email" placeholder="user@organization.sa" value={formData.email} onChange={handleInputChange} required />
          </div>
          <div className="form-group">
            <label>Phone Number</label>
            <input type="text" name="phone" placeholder="+966 50 123 4567" value={formData.phone} onChange={handleInputChange} required />
          </div>
          <div className="form-group">
            <label>Role</label>
            <select name="role" value={formData.role} onChange={handleInputChange}>
              <option value="admin">Admin</option>
              <option value="operator">Operator</option>
            </select>
          </div>
        </div>

        <div className="modal-footer">
          {mode === 'create' ? (
            <>
              <button className="btn-cancel" onClick={onClose}>Cancel</button>
              <button className="btn-submit" onClick={() => onSave(formData)}>Create user</button>
            </>
          ) : (
            <>
              <button className="btn-edit" onClick={() => onSave(formData)}>Save Changes</button>
              {/* SMART DEACTIVATE/ACTIVATE BUTTON */}
              <button 
                className="btn-deactivate" 
                style={{ backgroundColor: formData.is_active ? '#D04545' : '#4CAF50' }}
                onClick={() => onToggleActive(formData)}
              >
                {formData.is_active ? 'Deactivate' : 'Activate'}
              </button>
            </>
          )}
        </div>

      </div>
    </div>
  );
};

export default UserModal;
